import React, { forwardRef } from 'react';
import { styled } from '@mui/material/styles';
import Tooltip, {
  tooltipClasses as muiTooltipClasses
} from '@mui/material/Tooltip';
import PropTypes from 'prop-types';

const TooltipRoot = styled(
  forwardRef(({ className, ...rest }, ref) => (
    <Tooltip {...rest} ref={ref} classes={{ popper: className }} />
  )),
  { name: 'AFConditionalTooltip', shouldForwardProp: prop => prop !== 'hide' }
)(({ hide }) => ({
  [`& .${muiTooltipClasses.tooltip}`]: {
    // We need to manually hide the tooltip and keep it mounted
    // Otherwise, every time the tooltip is mounted it wil hijack the focus from the TextField (while typing)
    display: hide ? 'none' : 'block'
  }
}));

const ConditionalTooltip = forwardRef(({ hide, title = '', ...rest }, ref) => {
  return <TooltipRoot ref={ref} title={title} hide={hide} {...rest} />;
});

ConditionalTooltip.propTypes = {
  hide: PropTypes.bool,
  title: PropTypes.string
};

export default ConditionalTooltip;
